import { useEffect, useState } from 'react'
import Nav from './Nav'
import { RecordList } from './Record'
import Search from './Search'

//const ARCHIVE_DISPLAY = ['依日期顯示', '依公司顯示']

export const addingSummaries = (data) => {
    let newData = []
    let totalData = { _id: 'total', total: 0 }
    let yearData = { _id: '', year: '', total: 0 }
    let monData = { _id: '', year: '', month: '', expense: 0, income: 0 }
    newData.push(totalData)
    data.forEach((d) => {
        const date = d.date.split('-')
        const y = date[0]
        const m = date[1]
        if (yearData._id !== y) {
            yearData = { _id: y, year: y, total: 0 }
            newData.push(yearData)
        }
        if (monData._id !== y + m) {
            monData = { _id: y + m, year: y, month: m, expense: 0, income: 0 }
            newData.push(monData)
        }
        newData.push(d)

        let fee = d.cfee ? d.cfee : d.cfee === 0 ? 0 : d.fee
        if (d.action === 'buy') {
            totalData.total -= (d.amount + fee)
            yearData.total -= (d.amount + fee)
            monData.expense += (d.amount + fee)
        } else {
            totalData.total += (d.amount - fee)
            yearData.total += (d.amount - fee)
            monData.income += (d.amount - fee)
        }
    })

    return newData
}

const Archive = ({ theme, onClose, transactions, setTransaction,
    searching, setSearching, searchContext, setSearchContext }) => {

    const [transData, setTransData] = useState(transactions)

    useEffect(() => {
        if (searchContext.length > 0) {
            setTransData(transactions.filter(t => t.id === searchContext.split(' ')[0]))
        } else {
            setTransData(transactions)
        }

    }, [transactions, searchContext])

    const data = addingSummaries(transData)
    const handler = {
        setTransaction
    }

    const openSearch = () => {
        window.location.hash = 'search'
        setSearching(true)
    }

    const closeSearch = () => {
        window.history.back()
        setSearching(false)
    }

    const search = (item) => {
        setSearchContext(item)
        closeSearch()
    }

    const txt = theme === 'dark' ? 'text-white' : 'text-black'
    const inputCls = theme === 'dark' ? 'sb-input-dark' : 'sb-input-light'
    const inputBtn = theme === 'dark' ? 'btn-dark' : 'btn-light'

    return (
        <>
            {
                searching ? <Search theme={theme} setItem={search} onClose={closeSearch} /> :
                    <>
                        <Nav theme={theme} title="封存紀錄" onBack={onClose} />
                        <div className='d-flex justify-content-between p-2'>
                            <input className={"form-control " + txt + " " + inputCls} type="text" value={searchContext}
                                placeholder="搜尋個股" onFocus={openSearch} />
                            {searchContext &&
                                <button type="button" className={"ml-1 btn " + inputBtn} onClick={() => setSearchContext('')}>
                                    <i className="bi bi-x-lg"></i>
                                </button>
                            }
                        </div>
                        {data && <RecordList data={data} handler={handler} />}
                    </>
            }
        </>

    )
}

export default Archive